<template>
    <div class="chat-wrapper">

        <div class="chats">
            <transition-group name="fade" tag="span">
                <span class="chat-typer" v-for="typer in typingParticipants" :key="typer.id">{{ typer.name }} is typing ...</span>
            </transition-group>

            <div class="chats-group" v-for="clustered in clusteredChats">
                <div v-for="(chat, $index) in reverse(clustered)"
                     :class="{
                         'chat--mine': chat.mine,
                         'chat': typeof chat.mine !== 'undefined',
                         'chat-status': typeof chat.mine === 'undefined'
                     }">
                    <span v-if="typeof chat.mine !== 'undefined'">
                        <b v-if="$index === 0 && ! chat.mine">{{ chat.user.name }}</b>
                        {{ chat.message }}
                        <small class="time">{{ chat.createdAt | readableDate('YYYY-MM-DD HH:mm:ss', 'HH:mm') }}</small>
                        <span v-if="chat.mine" class="status">
                            <span v-if="isRead(chat.statuses) || isReceived(chat.statuses)"
                                  :class="{ 'status-read': isRead(chat.statuses) }"
                            >
                                <icon name="check"></icon>
                                <icon name="check"></icon>
                            </span>
                            <span v-else>
                                <icon name="check"></icon>
                            </span>
                        </span>
                    </span>
                    <span v-else>
                        <i v-if="chat.createdAt && ! isCreator(chat.user)">{{ chat.createdAt | readableDate('YYYY-MM-DD HH:mm:ss', 'DD. MMMM YYYY, HH:mm:ss') }} {{ chat.user.name }} ist beigetreten</i>
                        <i v-if="chat.createdAt && isCreator(chat.user)">{{ chat.createdAt | readableDate('YYYY-MM-DD HH:mm:ss', 'DD. MMMM YYYY, HH:mm:ss') }} {{ chat.user.name }} hat den Chat erstellt</i>
                        <i v-if="chat.deletedAt">{{ chat.deletedAt | readableDate('YYYY-MM-DD HH:mm:ss', 'DD. MMMM YYYY, HH:mm:ss') }} {{ chat.user.name }} ist ausgetreten</i>
                    </span>
                </div>
            </div>
        </div>

        <footer class="new-message">
            <div class="clearfix">
                <textarea v-model="message" ref="textarea" @keydown="isTyping" @keydown.shift.enter.prevent="submit"></textarea>
                <button :title="$t('common.button.send')" @click="submit"><icon name="send" /></button>
            </div>
        </footer>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { computed, methods } from '../../helpers/channelChat'

export default
{
    name: 'Chat',

    mixins: [computed, methods],

    data() {
        return {
            timeouts: {},
            typing: [],
            participants: [],
            chats: [],
            message: '',
        }
    },

    computed:
    {
        ...mapState({
            unreadChats: ({ chat }) => chat.unreadChats,
            user: ({ current }) => current.membership.id
        }),

        channel()
        {
            return {
                id: this.$route.params.channel
            };
        },

        clusteredParticipants()
        {
            let clustered = {},
                unqKey = '_ca';

            _.forEach(this.participants, participant =>
            {
                if (typeof clustered[`${participant.createdAt}${unqKey}`] === 'undefined')
                    clustered[`${participant.createdAt}${unqKey}`] = [];

                clustered[`${participant.createdAt}${unqKey}`].push({ createdAt: participant.createdAt, user: participant.user });
            })

            return clustered;
        },

        clusteredHistoryParticipants()
        {
            let clustered = {},
                unqKey = '_da';

            _.forEach(this.participants, participant =>
            {
                if (participant.deletedAt === null) return;

                if (typeof clustered[`${participant.deletedAt}${unqKey}`] === 'undefined')
                    clustered[`${participant.deletedAt}${unqKey}`] = [];

                clustered[`${participant.deletedAt}${unqKey}`].push({ deletedAt: participant.deletedAt, user: participant.user });
            })

            return clustered;
        },

        sortedChats()
        {
            let participants = this.clusteredParticipants,
                historyParticipants = this.clusteredHistoryParticipants,
                chats = _.keyBy(this.chats, 'createdAt');

            return _.merge(chats, participants, historyParticipants);
        },

        clusteredChats()
        {
            let clustered = [],
                creator = null,
                iterator = -1,
                sortedKeys = Object.keys(this.sortedChats).sort().reverse();

            _.forEach(sortedKeys, key =>
            {
                if (typeof this.sortedChats[key].user === 'undefined' && typeof this.sortedChats[key].mine === 'undefined')
                {
                    iterator++;
                    creator = null;
                    clustered[iterator] = this.sortedChats[key];
                }
                else
                {
                    if (this.sortedChats[key].user.id === creator)
                    {
                        clustered[iterator].push(this.sortedChats[key]);
                    }
                    else
                    {
                        creator = this.sortedChats[key].user.id;
                        iterator++;
                        clustered[iterator] = [];
                        clustered[iterator].push(this.sortedChats[key]);
                    }
                }
            });

            return clustered;
        },

        typingParticipants()
        {
            let typer = [];

            _.forEach(this.typing, p =>
            {
                if (!! p.typing)
                {
                    typer.push(p)
                }
            })

            return typer
        }
    },

    created()
    {
        this.$http.silent().get('/api/channels/' + this.channel.id)
        .then(response =>
        {
            this.$store.dispatch('chat/setActiveChannelInfos', response.data.channel);
            this.chats = response.data.chats;
            this.participants = response.data.participants;
            this.typing = _.map(this.participants, o => {
                return {
                    name: o.user.name,
                    id: o.user.id,
                    typing: false
                }
            })
        })
        .catch(error =>
        {
            this.$onduro.redirect('chats');
        });

        Echo.private('chat.' + this.channel.id).listenForWhisper('typing', (e) =>
        {
            let index = _.findIndex(this.typing, { id: e.user })

            if (index !== -1)
            {
                this.typing[index].typing = e.typing

                if (typeof this.timeouts[e.user] !== 'undefined')
                    clearTimeout(this.timeouts[e.user])

                // remove is typing indicator after 0.9s
                this.timeouts[e.user] = setTimeout(() =>
                {
                    this.clearTyper(index)
                }, 900)
            }
        })
    },

    mounted()
    {
        this.$refs['textarea'].focus();
        this.$store.dispatch('chat/setActiveChannel', this.channel.id);
        this.refreshUnreadChats(this.unreadChats, this.channel.id);

        Echo.private('channel.' + this.channel.id)
            .listen('ChatMessageSent', (e) =>
            {
                e.chat.mine = false; // broadcast events are always for others only
                this.updateChats(e.chat);
            })
            .listen('StatusUpdate', (e) =>
            {
                this.refreshReadStatus(e);
            });
    },

    beforeDestroy()
    {
        this.$store.dispatch('chat/setActiveChannel', null);
        this.$store.dispatch('chat/setActiveChannelInfos', {});
    },

    methods:
    {
        intersection(o1, o2) {
            return Object.keys(o1).filter({}.hasOwnProperty.bind(o2));
        },

        countStatus(key, statuses)
        {
            return {
                total: Object.keys(statuses).length,
                status: _.map(_.filter(statuses, status => status[key] !== null), key).length
            }
        },

        isRead(statuses)
        {
            if ( ! statuses) return false;

            let countStatuses = this.countStatus('readAt', statuses);

            return (countStatuses.total === countStatuses.status)
        },

        isReceived(statuses)
        {
            if ( ! statuses) return false;

            let countStatuses = this.countStatus('receivedAt', statuses);

            return (countStatuses.status >= 1)
        },

        updateChats(chat)
        {
            this.chats.push(chat);
        },

        submit()
        {
            this.$http.post('/api/channels/' + this.channel.id + '/chats',
            {
                message: this.message
            }).then(response =>
            {
                this.updateChats(response.data);
            })
            .catch( error =>
            {
                console.log(error);
            });

            this.message = '';
        },

        reverse(val)
        {
            return val.slice().reverse();
        },

        refreshReadStatus(data)
        {
            let i = 0;

            if (data.status === 'read')
            {
                return _.forEach(this.chats, chat =>
                {
                    if (chat.mine && ! this.isRead(chat.statuses))
                    {
                        let index = _.findIndex(chat.statuses, { membershipId: data.membership });

                        if (index !== -1) this.chats[i].statuses[index].readAt = 'true'
                    }

                    i++;
                })
            }

            return _.forEach(this.chats, chat =>
            {
                if (chat.mine && ! this.isReceived(chat.statuses))
                {
                    let index = _.findIndex(chat.statuses, { membershipId: data.membership });

                    if (index !== -1) this.chats[i].statuses[index].receivedAt = 'true'
                }

                i++;
            })
        },

        isCreator(user)
        {
            return _.find(this.participants, { user: {id: user.id }}).role === 'creator'
        },

        isTyping(e)
        {
            let channel = Echo.private('chat.' + this.channel.id),
                filter = [9, 91, 18, 27];

            if (filter.indexOf(e.keyCode) !== -1) return;

            setTimeout(() =>
            {
                channel.whisper('typing', {
                    user  : this.user,
                    typing: true
                })
            }, 300)
        },

        clearTyper(index)
        {
            this.typing[index].typing = false
        }
    }
}
</script>



// WEBPACK FOOTER //
// Chat.vue?4e7868dc